import { defineComponent as _defineComponent } from 'vue'
import { onMounted, Ref, ref, watch} from 'vue';
import router from '@/router/index';
import {useStore} from "@/store";
import moment from "moment-mini";
import Services from "@/assets/js/services/Services";
import vuetify from "@/plugins/vuetify";
import AproconHeader from "@aprocon-software/aprocon-header";
import ApplicationCard from '@/components/ApplicationCard.vue';
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const store = useStore();
let currentRouter: any | undefined;
let branchName: Ref<string> = ref("");
const loading = ref(true);
const apps : Ref<any[]> = ref([]);
const filteredApps : Ref<any[]> = ref([]);
const searchApps: Ref<string> = ref("");
let clockTimer!: any;
const isLoggedIn:Ref<boolean> = ref(true);
async function created() {

    setCurrentTime();
    selectedBranch();
    currentRouter = router;
    watch(() => searchApps.value, searchAppsChanged);
    onMounted(() => mounted());

}

async function mounted() {
    const authToken = store.getters.authToken();
    isLoggedIn.value =  authToken !== null && authToken !== '';
    apps.value = await Services.Apps.getApplications(store.getters.branchId());
    searchAppsChanged();
    loading.value = false;
}

const currentTime:Ref<string> = ref("");
const currentDate:Ref<string> = ref("");

// function getBadges(appID:string): {APPID:string, APPAREA:string,COLOR:string,BADGETEXT:string,EXTENSIVETEXT:string}[]{
//     const badgesResult = badges.find((badge)=>badge.APPID === appID);
//     if(badgesResult) {
//         return badges;
//     }
//     return [];
// }
async function logout(): Promise<void> {
    // const loginServiceDomain = process.env.VUE_APP_LOGIN_URL;
    // await axios.post(`${loginServiceDomain}/logoff`, { SID: store.getters.authToken });
    branchName.value = ' ';
    isLoggedIn.value = false;
    await store.dispatch('logout');
    //await currentRouter.push('/LogOff');


}
function setCurrentTime(): void {
    const date = new Date();
    const now = moment(date);
    const seconds = now.seconds();

    currentTime.value = moment(date).format('HH:mm');
    currentDate.value = moment(new Date()).format('dddd , DD.MM.YYYY');
    if (clockTimer) {
        window.clearTimeout(clockTimer);
    }
    clockTimer = window.setTimeout(setCurrentTime, (60 - seconds) * 1000);
}

function selectedBranch() {
    Services.Apps.getBranches(store.getters.userId()).then((items) => {
        items.find(item => {
            if (item.Nummer == store.getters.branchId()) {
                branchName.value = item.Name;
                return true;
            }
            return false;
        });
    });
}
function searchAppsChanged() {
    if (!searchApps.value ) {
        searchApps.value = '';
    }
    const search: string = searchApps.value;
    filteredApps.value = apps.value.filter((app) => app.MANIFEST.TITLE.toLowerCase().includes(search.toLowerCase()) || app.MANIFEST.HEADER.toLowerCase().includes(search.toLowerCase()) || app.MANIFEST.DETAILS.toLowerCase().includes(search.toLowerCase()));
}

created();

return { __sfc: true,store, currentRouter, branchName, loading, apps, filteredApps, searchApps, clockTimer, isLoggedIn, created, mounted, currentTime, currentDate, logout, setCurrentTime, selectedBranch, searchAppsChanged, vuetify, AproconHeader, ApplicationCard }
}

})